import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import {
  LayoutDashboard, Monitor, ListVideo, FolderOpen, Calendar,
  Settings, LogOut, Sun, Moon, AlertTriangle
} from 'lucide-react';
import ImaLogo from '../ImaLogo';

export default function Sidebar() {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/login'); };

  const links = [
    { section: 'Overview', items: [
      { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
    ]},
    { section: 'Management', items: [
      { to: '/devices', icon: Monitor, label: 'TV Devices' },
      { to: '/playlists', icon: ListVideo, label: 'Playlists' },
      { to: '/media', icon: FolderOpen, label: 'Media Library' },
      { to: '/schedules', icon: Calendar, label: 'Schedules' },
    ]},
    { section: 'System', items: [
      { to: '/emergency', icon: AlertTriangle, label: 'Emergency' },
      { to: '/settings', icon: Settings, label: 'Settings' },
    ]},
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <ImaLogo size={38} />
        <div>
          <h1>IMA TV</h1>
          <span>v1.0.0</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        {links.map((section) => (
          <div className="sidebar-section" key={section.section}>
            <div className="sidebar-section-title">{section.section}</div>
            {section.items.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
              >
                <link.icon />
                {link.label}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="theme-toggle" style={{ marginBottom: 12 }}>
          <button
            className={`theme-toggle-btn ${theme === 'light' ? 'active' : ''}`}
            onClick={() => theme !== 'light' && toggleTheme()}
          >
            <Sun size={14} />
          </button>
          <button
            className={`theme-toggle-btn ${theme === 'dark' ? 'active' : ''}`}
            onClick={() => theme !== 'dark' && toggleTheme()}
          >
            <Moon size={14} />
          </button>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>
            {user?.display_name || user?.username}
          </span>
          <button className="btn btn-ghost btn-sm" onClick={handleLogout}>
            <LogOut size={14} /> Logout
          </button>
        </div>
      </div>
    </aside>
  );
}
